module.exports = __webpack_public_path__ + "static/img/sy-4.cf4f511.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/sy-4.png
// module id = ykE0
// module chunks = 63